import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IWhatsappAutoTrigger,
  IWhatsappAutoTriggerState,
} from "./whatsappAutoTriggerModel";
import {
  createWhatsappAutoTrigger,
  deleteWhatsappAutoTrigger,
  duplicateWhatsappAutoTrigger,
  getAllWhatsappAutoTriggers,
  getWhatsappAutoTriggerByID,
  updateWhatsappAutoTrigger,
} from "./services/whatsappAutoTrigger.services";

const initialState: IWhatsappAutoTriggerState = {
  loading: false,
  error: "",
  WhatsappAutoTriggerID: null,
  WhatsappAutoTriggerList: [],
  WhatsappAutoTriggerDetail: {
    TriggerName: "",
    Module: "",
    Operation: "",
    Whats_App_To: "",
    DelayDay: null,
    DelayHour: null,
    DelayTime: null,
    TriggerTemplateID: null,
  },
  FilterWhatsappAutoTrigger: {
    TriggerName: "",
    Module: "",
    Operation: "",
    Whats_App_To: "",
  },
};

const whatsappAutoTriggerSlice = createSlice({
  name: "whatsappAutoTrigger",
  initialState,
  reducers: {
    clearWhatsappAutoTriggerDetails: (state) => {
      state.WhatsappAutoTriggerDetail = initialState.WhatsappAutoTriggerDetail;
    },
    setWhatsappAutoTriggerID: (state, action) => {
      state.WhatsappAutoTriggerID = action.payload;
    },
    clearWhatsappAutoTriggerID: (state) => {
      state.WhatsappAutoTriggerID = initialState.WhatsappAutoTriggerID;
    },
    setFilterWhatsappAutoTrigger: (state, action) => {
      state.FilterWhatsappAutoTrigger = action.payload;
    },
    clearFilterWhatsappAutoTrigger: (state) => {
      state.FilterWhatsappAutoTrigger = initialState.FilterWhatsappAutoTrigger;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWhatsappAutoTriggers.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWhatsappAutoTriggers.fulfilled,
      (state, action: PayloadAction<IWhatsappAutoTrigger[]>) => {
        state.loading = false;
        state.WhatsappAutoTriggerList = action.payload || [];
      }
    );
    builder.addCase(getAllWhatsappAutoTriggers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WhatsappAutoTriggerList = [];
    });
    builder.addCase(createWhatsappAutoTrigger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createWhatsappAutoTrigger.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(createWhatsappAutoTrigger.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWhatsappAutoTrigger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWhatsappAutoTrigger.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(updateWhatsappAutoTrigger.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWhatsappAutoTrigger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWhatsappAutoTrigger.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWhatsappAutoTrigger.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWhatsappAutoTriggerByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getWhatsappAutoTriggerByID.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.WhatsappAutoTriggerDetail = action.payload;
      }
    );
    builder.addCase(getWhatsappAutoTriggerByID.rejected, (state, action) => {
      state.loading = false;
      state.WhatsappAutoTriggerDetail = initialState.WhatsappAutoTriggerDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(duplicateWhatsappAutoTrigger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(duplicateWhatsappAutoTrigger.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(duplicateWhatsappAutoTrigger.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearWhatsappAutoTriggerDetails,
  clearWhatsappAutoTriggerID,
  setWhatsappAutoTriggerID,
  setFilterWhatsappAutoTrigger,
  clearFilterWhatsappAutoTrigger,
} = whatsappAutoTriggerSlice.actions;
export default whatsappAutoTriggerSlice.reducer;
